module.exports = __webpack_public_path__ + "img/bybit_5.9803bb39.png";